// extracted by mini-css-extract-plugin
export var angleRight = "related-posts-module--angle-right---Pmrk";
export var container = "related-posts-module--container--n5KvY";
export var header = "related-posts-module--header--tnhEA";
export var post = "related-posts-module--post--4Vinu";